'use client';

import { useMemo, useState } from 'react';
import { calculateCurrentRatio } from './calculations';
import { CurrentRatioValues } from './types';
import CalculatorInputs from './CalculatorInputs';
import ResultsDisplay from './ResultsDisplay';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  translations: ToolsTranslations['currentRatio'];
}

export default function CurrentRatioCalculator({ translations }: Props) {
  const [values, setValues] = useState<CurrentRatioValues>({
    currentAssets: 300000,
    inventory: 0,
    workInProgress: 0,
    currentLiabilities: 50000,
  });

  const handleValuesChange = (field: keyof CurrentRatioValues, value: number) => {
    setValues(prev => ({ ...prev, [field]: value }));
  };

  const result = useMemo(() => calculateCurrentRatio(values, translations), [values, translations]);

  return (
    <section id="current-ratio-calculator" className="w-full my-12 tools">
      <div className="rounded-xl border border-gray-200 shadow-sm bg-white">
        <div className="p-6 border-b border-gray-100">
          <div>
            <h2 className="text-xl font-semibold text-blue-900">{translations.title}</h2>
            <p className="text-sm text-gray-600 mt-1">{translations.subtitle}</p>
          </div>
        </div>
        <div className="p-6 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <CalculatorInputs values={values} onValuesChange={handleValuesChange} translations={translations} />
          <ResultsDisplay result={result} translations={translations} />
        </div>
      </div>
    </section>
  );
}


